"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("auto-widget-framework/src/Error/WidgetError");
class EndpointError extends WidgetError_1.default {
    constructor(message, response) {
        super(message);
        this.response = response;
        // Explicitly set proto.
        Object.setPrototypeOf(this, EndpointError.prototype);
        this.name = this.getCode();
    }
    getResponseStatus() {
        return this.response.status;
    }
    getResponseMessage() {
        return this.response.message;
    }
    getErrorCode() {
        try {
            return Number.parseInt(this.response.code, 10);
        }
        catch (e) {
            console.warn("Endpoint error with unparsed error code.");
            return 0;
        }
    }
}
exports.default = EndpointError;
EndpointError.code = "PX-ENDPOINT";
